import { render } from "./UserCard.vue?vue&type=template&id=022cbbd7"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=022cbbd7&lang=css"
script.render = render

export default script